import { render, staticRenderFns } from "./ApplePay.vue?vue&type=template&id=44c4166c&"
import script from "./ApplePay.vue?vue&type=script&lang=js&"
export * from "./ApplePay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports